// extracted by mini-css-extract-plugin
module.exports = {"apmRoot":"SPSAlternative_apmRoot__1jLnO","apmRootShift":"SPSAlternative_apmRootShift__2Hnee"};